import { ESdChangeReason, ISdAlternative } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { IWithHistoryProp, withHistory } from "../../../shared/hoc/with-history";
import { PureSdComponent } from "../../../shared/pure-sd";
import { KModal } from "../../ui-kit/k-modal/k-modal";
import { KModalFooter } from "../../ui-kit/k-modal/k-modal-footer";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../ui-kit/kuika-selectbox/kuika-selectbox";

export interface IAlternativeScreensModalState {
  selectedScreenId?: string;
  isSubmitButtonLoading: boolean;
}

export interface IAlternativeScreensModalProps {
  alternativeSdList: ISdAlternative[];
}

class AlternativeScreensModal extends PureSdComponent<
  IAlternativeScreensModalProps & IWithSDProps & IWithHistoryProp,
  IAlternativeScreensModalState
> {
  constructor(props: IAlternativeScreensModalProps & IWithSDProps & IWithHistoryProp) {
    super(props);
    this.state = { selectedScreenId: undefined, isSubmitButtonLoading: false };
  }

  /** The primitive draws the tick on the chosen row, so the option is just the name. */
  getScreenOptions = (): KuikaSelectboxOption[] =>
    (this.props.alternativeSdList ?? []).map((screen: ISdAlternative): KuikaSelectboxOption => ({
      key: screen.id,
      value: screen.id,
      label: screen.name,
      searchLabel: screen.name
    }));

  handleSelectScreen = (sdId) => {
    this.props.sd.setIsAlternativeSdModalActive(false);
    this.props.sd.loadScreen(sdId);
  };

  render() {
    return (
      <>
        <KModal
          header="SCREEN ALREADY IN USE"
          className="kuika_alternative-screens-modal"
          showModal={this.props.sd.isAlternativeSdModalActive}
          hideCloseIcon={true}
          footer={
            <KModalFooter
              submitLabel="Go to screen"
              submitTestId="alternativeScreensGoToScreenButton"
              onSubmit={() => {
                if (this.state.selectedScreenId) this.handleSelectScreen(this.state.selectedScreenId);
              }}
              disabled={!this.state.selectedScreenId}
            />
          }
          width={395}
        >
          <div style={{ padding: 16 }}>
            <div className="kuika_alternative-screens-modal__icon">
              <svg width="97" height="95" viewBox="0 0 97 95" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.45345 22.8685C9.49782 22.7994 9.54653 22.7231 9.5996 22.64C11.8394 19.1326 21.8503 3.45586 41.6989 0.892805L41.6349 0.396922L41.6989 0.892804C54.028 -0.699427 68.3934 2.51664 78.7799 11.113C89.6721 20.1281 94.7523 33.7617 95.259 47.086C95.7662 60.4215 91.6892 73.3491 84.3941 80.9362C82.4724 82.9347 80.6548 84.2239 79.1938 85.2597C62.1796 97.3199 42.0187 93.8097 37.7122 92.9458C31.3234 91.6641 19.1402 89.2093 10.3382 78.984C-2.9763 63.5156 -0.940014 39.0578 9.45345 22.8685ZM9.45345 22.8685L9.03271 22.5984L9.45347 22.8685C9.45346 22.8685 9.45346 22.8685 9.45345 22.8685Z"
                  fill="#F7F8F9"
                  stroke="#F1F2F4"
                />
                <path d="M40.9179 65.9207L38.8684 84.3021H62.6466L59.5494 65.9207H40.9179Z" fill="#C7B3FF" />
                <path
                  d="M0.974365 20.6332V62.7312C0.974365 66.1941 3.73415 69.0265 7.19612 69.1155C22.5725 69.512 76.3511 70.4733 90.9882 70.2577C93.504 70.2206 95.542 68.2075 95.6146 65.6924C95.8967 55.9125 96.3552 32.3951 94.659 21.4768C94.3017 19.1775 92.3611 17.458 90.0353 17.3838C77.1518 16.9718 20.1431 15.6629 5.51271 15.9916C2.98946 16.0483 0.974703 18.1093 0.974703 20.6332H0.974365Z"
                  fill="#AC8EFF"
                />
                <path
                  d="M3.61597 20.4285V60.4247C3.61597 62.4465 5.23897 64.0942 7.26081 64.1245L88.8825 65.1331C90.8868 65.1631 92.5301 63.5506 92.5375 61.546L92.6741 21.9071C92.6795 20.4738 91.5377 19.2992 90.1047 19.2644L6.53907 17.5763C4.9363 17.5372 3.61597 18.8258 3.61597 20.4289V20.4285Z"
                  fill="#C7B3FF"
                />
                <path
                  opacity="0.65"
                  d="M93.1518 66.7731H93.1497L3.61378 65.2476C3.55035 65.2466 3.49974 65.1943 3.50075 65.1309C3.5021 65.0674 3.55946 65.0168 3.6175 65.0178L93.1535 66.5433C93.2169 66.5443 93.2675 66.5966 93.2665 66.6601C93.2655 66.7228 93.2142 66.7731 93.1518 66.7731Z"
                  fill="white"
                />
                <path
                  opacity="0.65"
                  d="M49.2671 68.6362C48.6901 68.6362 48.2207 68.1668 48.2207 67.5898C48.2207 67.0128 48.6901 66.5435 49.2671 66.5435C49.844 66.5435 50.3134 67.0128 50.3134 67.5898C50.3134 68.1668 49.844 68.6362 49.2671 68.6362ZM49.2671 66.7729C48.8166 66.7729 48.4501 67.1393 48.4501 67.5898C48.4501 68.0403 48.8166 68.4067 49.2671 68.4067C49.7175 68.4067 50.084 68.0403 50.084 67.5898C50.084 67.1393 49.7175 66.7729 49.2671 66.7729Z"
                  fill="white"
                />
                <path
                  d="M67.7689 88.0629H32.9674C32.022 88.0629 31.312 87.3897 31.4949 86.667L31.9413 84.9009C32.0756 84.3698 32.66 83.9797 33.3538 83.9581L66.9035 82.9111C67.6286 82.8885 68.2704 83.2735 68.4286 83.8252L69.2337 86.6383C69.4429 87.3691 68.7296 88.0629 67.7686 88.0629H67.7689Z"
                  fill="#C7B3FF"
                />
                <path
                  d="M51.7019 84.4379C51.6391 84.4379 51.5878 84.3876 51.5872 84.3248C51.5862 84.2614 51.6371 84.2091 51.7002 84.2084L53.138 84.1875H53.1397C53.2024 84.1875 53.2537 84.2378 53.2544 84.3005C53.2554 84.364 53.2044 84.4163 53.1413 84.4169L51.7036 84.4379H51.7019Z"
                  fill="white"
                />
                <path
                  d="M32.7831 87.0909C32.777 87.0909 32.7709 87.0905 32.7649 87.0895C32.7021 87.0794 32.6596 87.0207 32.6694 86.9579L32.8745 85.6734C32.9849 84.9823 33.5727 84.4735 34.2721 84.463L49.5206 84.24H49.5223C49.5851 84.24 49.6364 84.2903 49.637 84.353C49.6381 84.4165 49.5871 84.4688 49.524 84.4694L34.2755 84.6925C33.6877 84.7012 33.1941 85.1288 33.1013 85.7091L32.8961 86.9937C32.887 87.0504 32.8384 87.0905 32.7827 87.0905L32.7831 87.0909Z"
                  fill="white"
                />
                <g clipPath="url(#clip0_13452_283339)">
                  <path
                    d="M65.4636 42.1615H61.1101V18.466C61.1101 12.8874 56.57 8.3535 50.9975 8.3535C45.4251 8.3535 40.885 12.8936 40.885 18.466V42.1615H36.5315V18.466C36.5315 10.4929 43.0182 4 50.9975 4C58.9769 4 65.4636 10.4929 65.4636 18.466V42.1615Z"
                    fill="#E04441"
                  />
                  <path
                    d="M66.8815 31.626H35.1134C33.1178 31.626 31.5 33.2438 31.5 35.2394V53.0327C31.5 55.0284 33.1178 56.6461 35.1134 56.6461H66.8815C68.8771 56.6461 70.4949 55.0284 70.4949 53.0327V35.2394C70.4949 33.2438 68.8771 31.626 66.8815 31.626Z"
                    fill="#122C4B"
                  />
                  <path
                    d="M54.2561 40.8741C54.2561 42.6715 52.7946 44.133 50.9972 44.133C49.1998 44.133 47.7383 42.6715 47.7383 40.8741C47.7383 39.0768 49.1998 37.6152 50.9972 37.6152C52.7946 37.6152 54.2561 39.0768 54.2561 40.8741Z"
                    fill="white"
                  />
                  <path d="M51.8869 42.1616H50.1082V48.866H51.8869V42.1616Z" fill="white" />
                  <path
                    d="M33.5772 54.2704C33.4902 54.2704 33.4155 50.0973 33.4155 44.9539C33.4155 39.8106 33.4902 35.6375 33.5772 35.6375C33.6643 35.6375 33.7389 39.8106 33.7389 44.9539C33.7389 50.0973 33.6643 54.2704 33.5772 54.2704Z"
                    fill="#FAFAFA"
                  />
                  <path
                    d="M48.4475 45.0536C48.4475 45.0536 48.292 45.0038 48.0681 44.8359C47.838 44.6742 47.5333 44.3881 47.2285 43.9776C46.619 43.1816 46.0655 41.7325 46.4262 40.1714C46.8056 38.6104 47.95 37.5655 48.8518 37.124C49.3058 36.8939 49.71 36.7819 49.9837 36.7384C50.2635 36.6948 50.419 36.6948 50.4252 36.7135C50.4377 36.7757 49.8095 36.8317 48.9637 37.323C48.1303 37.7957 47.0917 38.8032 46.7434 40.2398C46.4076 41.6827 46.8865 43.051 47.4213 43.847C47.9562 44.668 48.4973 45.0038 48.4537 45.0473L48.4475 45.0536Z"
                    fill="#FAFAFA"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_13452_283339">
                    <rect width="38.9949" height="52.64" fill="white" transform="translate(31.5 4)" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div className="kuika_alternative-screens-modal__title">Screen Already In Use</div>
            <div className="kuika_alternative-screens-modal__description">
              <span className="kuika_alternative-screens-modal__occupied-screen-name">
                {this.props.sd.occupiedScreenName}
              </span>{" "}
              screen already in use by {this.props.sd.currentScreenOccupier}. Select another screen to work on down
              below.
            </div>
            <KuikaSelectbox
              className="kuika_alternative-screens-modal__selectbox"
              placeholder="Select a screen"
              searchable
              value={this.state.selectedScreenId}
              options={this.getScreenOptions()}
              onChange={(screenId) => this.setState({ selectedScreenId: String(screenId) })}
              data-testid="alternativeScreensSelect"
            />
          </div>
        </KModal>
      </>
    );
  }

  checkNeedRender = (
    changeReason: ESdChangeReason,
    nextProps: IAlternativeScreensModalProps & IWithSDProps & IWithHistoryProp
  ): boolean => {
    return this.props.sd.isAlternativeSdModalActive !== nextProps.sd.isAlternativeSdModalActive;
  };
}

const alternativeScreensModal = withHistory<IAlternativeScreensModalProps>(
  withSD<IAlternativeScreensModalProps>(AlternativeScreensModal)
);
export { alternativeScreensModal as AlternativeScreensModal };
